import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const TabTitle = styled.span`
  font-size: 14px;
  line-height: 20px;
  font-style: normal;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.black9};
`;

export const TabWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  cursor: pointer;
`;
